import { useQuery } from '@tanstack/react-query';
import { fetchData } from 'utils';
import useSmartlook from 'hooks/useSmartlook';

type ClientBankAccountNumber = {
  bankAccountNumber: string;
};
export default function useClientBankAccountQuery(enabled = true) {
  const { error } = useSmartlook();
  return useQuery<ClientBankAccountNumber>({
    queryKey: ['client', 'bank-account-number'],
    queryFn: async () => {
      try {
        const data = await fetchData('/client/bank-account-number');
        return data;
      } catch (e) {
        error('[useClientQuery][GET /client/bank-account-number]', e);
        throw e;
      }
    },
    enabled,
  });
}
